import { SET_ADD_NEW_GUEST_TENANT_OPENED } from "./tenant-guest-tenants-types";

export const setAddNewGuestTenant = (isAddNewGuestTenantOpened: boolean) => ({
    type: SET_ADD_NEW_GUEST_TENANT_OPENED,
    isAddNewGuestTenantOpened,
});
